import React from 'react'
import { Tooltip } from 'react-bootstrap'
import useWindowDimensions from '../../../../utils/useWindowDimensions';


const PredictiveDataSummery = ({ analytics, group }) => {
    let { width, height } = useWindowDimensions();
    return (
        <>
            {/* <div className="card for_predictive position-relative py-4 d-flex align-items-start justify-content-center" style={{ height: width > 1500 ? "263px" : "216px" }}> */}
            <div className="card for_predictive position-relative py-4 d-flex align-items-start justify-content-center" style={{ height: group ? (width > 1500 ? "263px" : "216px") : "auto" }}>
                <h5>Predictive Data Summary</h5>
                <div className="anydetail-foot p-0">
                    <p className="mb-0">
                        A : Task with maximum time taken : {" "}
                        <span className="text-bolder"><>{analytics?.maxTimeTakingTask}</></span>
                    </p>
                    <p className="mb-0">
                        B : Task with maximum error :{" "}
                        <span className="text-bolder"><>{analytics?.maxErrorProneTask}</></span>
                    </p>
                </div>
            </div>
        </>
    )
}

export default PredictiveDataSummery
